export const CONTACT_QUERY_PARAMS = {
  page: 1,
  perPage: 3,
};
